import actionTypes from './actionTypes';
import { action, generateErrorAction } from '../../actions';
import API from '../../../apis';

export const getCompletedReservesReport = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.completedReservesReport
        .fetchAllCompletedReservesReport(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.GET_COMPLETED_RESERVE_REPORT_FAILED,
              reject: actionTypes.GET_COMPLETED_RESERVE_REPORT_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.GET_COMPLETED_RESERVE_REPORT_LOADING);
  const success = res => action(actionTypes.GET_COMPLETED_RESERVE_REPORT_SUCCESS, res);

  return request();
};
